import React, { Component } from 'react';
import { connect } from 'react-redux';

import DataDictionaryPanel from './DataDictionaryPanel';
import { history } from '../../index';

class Main extends Component {

  render() {
    return (
      <DataDictionaryPanel
        onClose={() => {
          history.goBack();
        }} />
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})


export default connect(mapStateToProps)(Main)
